import React from 'react'
import * as  C from "../componentsM/index"

const CoreProgram = () => {
    return (
        <>

            <C.Hero title={"CORE PROGRAMME"}
                image={"/hero/12.jpg"} />


            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5'>

                    <p>In addition to the six subject groups, students must satisfactorily complete the following:</p>

                    <p>Extended Essay (EE)</p>


                    <p>The extended essay is an in-depth study of a focused topic chosen from the list of available Diploma Programme subjects for the session in question. This is normally one of the student’s six chosen subjects for those taking the IB diploma, or a subject that a course student has a background in. It is intended to promote academic research and writing skills, providing students with an opportunity to engage in personal research in a topic of their own choice, under the guidance of a supervisor (assigned by the school). This leads to a major piece of formally presented, structured writing, in which ideas and findings are communicated in a reasoned and coherent manner, appropriate to the subject chosen. This essay has to be 4,000 words maximum.</p>

                    <h1 className='text-xl md:text-3xl font-bold text-myBlue'>Theory of Knowledge (TOK)</h1>

                    <p>A required interdisciplinary course, which stimulates critical reflection upon the knowledge and experience gained inside and outside the classroom. It challenges students to question the basis of knowledge, to be aware of subjective and ideological biases, and to develop a personal mode of thought based on the analysis of evidence expressed in rational argument. The key element in the IBO’s educational philosophy, Theory of Knowledge seeks to develop a coherent approach to learning, which transcends and unifies the academic subjects and simultaneously encourages an appreciation of diverse cultural perspectives.</p>

                    <p>Although there is no final exam for this subject, students are graded on the basis of a presentation and an essay in order to qualify for the Diploma. The chart below shows the combined Diploma points awarded for TOK and the Extended Essay.</p>


                    <figure className='md:w-[50%]'>

                        <img src="/core.png" className='w-full h-full object-contain' />

                    </figure>


                    <h1 className='text-xl md:text-3xl font-bold text-myBlue'>Creativity, Activity, Service (CAS)</h1>


                    <p>CAS enables students to demonstrate attributes of the IB Learner Profile in real and practical ways, to grow as unique individuals and to recognize their role in relation to others. Students develop skills, attitudes and dispositions through a variety of individual and group experiences that provide students with opportunities to explore their interests and express their passions, personalities and perspectives. CAS complements a challenging academic programme in a holistic way, providing opportunities for self-determination, collaboration, accomplishment and enjoyment. CAS enables students to enhance their personal and interpersonal development.</p>


                    <p>A meaningful CAS programme is a journey of discovery of self and others. For many, CAS is profound and life-changing. Each individual student has a different starting point and different needs and goals. A CAS programme is, therefore, individualized according to student interests, skills, values and background.</p>



                </div>
            </section>

        </>

    )
}

export default CoreProgram